<template>
  <v-card flat>
    <v-toolbar>
      <v-card-title class="font-weight-light">{{ student.name }} </v-card-title>
    </v-toolbar>
    <v-toolbar flat class="ml-4 mt-4" height="60">
      <v-text-field type="date" label="Fecha" class="mx-4" v-model="date" @change="updateWhen"></v-text-field>
      <v-text-field type="time" label="Hora" class="mx-4" v-model="time" @change="updateWhen"></v-text-field>
    </v-toolbar>
    <v-card-text v-if="availables.length > 0" class="ma-0 pa-0">
      <v-card
        color="blue lighten-5"
        :key="index"
        v-for="(available, index) in availables"
        class="ma-3"
      >
        <v-toolbar dense height="35" color="primary" flat dark>
          <v-card-title>{{ available.name }} </v-card-title>
          <v-spacer></v-spacer>
          <span v-if="available.price" class="price"
            >{{ parseFloat(available.price).toFixed(2).replace(".", ",") }} € /
            mes</span
          >
        </v-toolbar>
        <v-card-text
          class="images ma-0 pa-0 mt-1"
          v-if="available.images && available.images.length > 0"
        >
          <v-img
            dark
            class="thumbnail"
            :key="index"
            v-for="(image, index) in available.images"
            :src="image.thumbnailUrl"
            width="78"
            height="70"
          >
          </v-img>
        </v-card-text>
        <v-card-text v-if="available.description">{{
          available.description
        }}</v-card-text>
        <v-divider></v-divider>
        <v-card-text class="pa-1">
          <v-btn
            class="pl-1 ma-1"
            :class="{
              'pr-13': Object.keys(group.students).indexOf(student.id) < 0,
            }"
            :color="
              Object.keys(group.students).indexOf(student.id) >= 0
                ? 'green'
                : 'primary'
            "
            rounded
            outlined
            :key="index"
            v-for="(group, index) in Object.values(available.groups).sort(
              (a, b) => {
                if (a.date < b.date) {
                  return -1;
                } else {
                  return 1;
                }
              }
            )"
            @click="enroll(student, available, group)"
          >

            <div v-if="group.schedule.trim() !== ''">
              <div
                class="when"
                :key="index"
                v-for="(when, index) in group.schedule.split('/')"
              >
                <v-avatar
                  size="27"
                  class="white--text mr-2 font-weight-bold"
                  :color="
                    Object.keys(group.students).indexOf(student.id) >= 0
                      ? 'green'
                      : 'primary'
                  "
                  >{{ when.split(" ")[0] }}</v-avatar
                >
                {{ when.split(" ")[1].replace("-", " - ") }}
                <v-icon v-if="index < group.schedule.split('/').length - 1"
                  >mdi-slash-forward</v-icon
                >
              </div>
            </div>
            <div v-else>
              <v-avatar
                size="27"
                class="white--text mr-2 font-weight-bold"
                :color="
                  Object.keys(group.students).indexOf(student.id) >= 0
                    ? 'green'
                    : 'primary'
                "
                ><v-icon small>mdi-help</v-icon></v-avatar
              >
              Horario por determinar
            </div>
            <span
              v-if="group.name && group.name.trim() !== ''"
              class="group-name"
              >({{ group.name }})</span
            >
            <v-icon
              v-if="Object.keys(group.students).indexOf(student.id) >= 0"
              color="green"
              large
              >mdi-check</v-icon
            >
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text class="pb-0">
          <!--<v-textarea
            :value="
              available.comments && available.comments[student.id]
                ? available.comments[student.id]
                : ''
            "
            @change="updateComment(available, student, $event)"
            rows="1"
            placeholder="Escribe aquí cualquier comentario, lo tendremos muy en cuenta."
            auto-grow
            label="Observaciones"
          ></v-textarea>-->
          <v-textarea
            :value="available.comments"
            @change="updateComment(available, student, $event)"
            rows="1"
            placeholder="Escribe aquí cualquier comentario, lo tendremos muy en cuenta."
            auto-grow
            label="Observaciones"
          ></v-textarea>
        </v-card-text>
      </v-card>
    </v-card-text>
    <v-card-text v-else>
      Lo sentimos, no hay ninguna actividad disponible para
      {{
        student.name.includes(",")
          ? student.name.split(",")[1].trim()
          : student.name
      }}.
    </v-card-text>
  </v-card>
</template>

<script>
/*eslint-disable no-console */
import { fs, activities, students } from "../firebaseConfig.js";

export default {
  props: ["student"],
  data() {
    return {
      availables: [],
      date: null,
      time: null,
      when: new Date(),
    };
  },
  methods: {
    updateWhen() {
      if (this.date && this.time) {
        let Y = this.date.split('-')[0];
        let M = this.date.split('-')[1]-1;
        let D = this.date.split('-')[2];
        let h = this.time.split(':')[0];
        let m = this.time.split(':')[1];
        console.log(Y,M,D,h,m)
        this.when = new Date(Y, M, D, h, m, 0);
        console.log(this.when)
      }
    },
    dayAvailable(a, b) {
      let result = true;
      for (let i = 0; i < a.length; i++) {
        if (b.includes(a[i])) {
          result = false;
          break;
        }
      }
      return result;
    },
    timeAvailable(a, b) {
      let ai =
        a.split("-")[0].split(":")[0] * 60 + a.split("-")[0].split(":")[1];
      let af =
        a.split("-")[1].split(":")[0] * 60 + a.split("-")[1].split(":")[1];
      let bi =
        b.split("-")[0].split(":")[0] * 60 + b.split("-")[0].split(":")[1];
      let bf =
        b.split("-")[1].split(":")[0] * 60 + b.split("-")[1].split(":")[1];
      return (ai < bi && af <= bi) || (ai >= bf && af > bf);
    },
    /*resolveAvailability(group) {
      let result = false;
      if(group.schedule === '') {
        return result;
      } else {
        let schedules = group.schedule.split('/');
        let studentSchedules = [];
        if(this.student.activities) {
          Object.values(this.student.activities).forEach((activity)=>{
            if(group.id !== activity.id) {
              studentSchedules = studentSchedules.concat(activity.schedule.split('/'));
            }
          });
        }
        for(let i=0; i<schedules.length; i++) {
          for(let j=0; j<studentSchedules.length; j++) {
            let available = !this.dayAvailable(schedules[i].split(' ')[0],studentSchedules[j].split(' ')[0]) && !this.timeAvailable(schedules[i].split(' ')[1],studentSchedules[j].split(' ')[1]);
              if(available) {
                result = true;
                break;
              }
          }
          if(result) break;
        }
        return result;
      }
    },*/
    enroll(son, activity, group) {
      if (
        Object.keys(activity.groups[group.id].students).indexOf(son.id) >= 0
      ) {
        let index = activity.groups[group.id].students[son.id].index;
        activities
          .doc(activity.id)
          .update({
            [`groups.${group.id}.students.${son.id}`]: fs.FieldValue.delete(),
          })
          .then(() => {
            activities
              .doc(activity.id)
              .get()
              .then((activityRef) => {
                Object.values(
                  activityRef.data().groups[group.id].students
                ).forEach((student) => {
                  if (student.index > index) {
                    activities.doc(activity.id).update({
                      [`groups.${group.id}.students.${student.id}.index`]:
                        fs.FieldValue.increment(-1),
                    });
                  }
                });
              });
          });
        students
          .doc(son.id)
          .update({
            [`activities.${group.id}`]: fs.FieldValue.delete(),
          })
          .then(() => {
            this.getAvailables();
          });
      } else {
        activities.doc(activity.id).update({
          [`groups.${group.id}.students.${son.id}`]: {
            id: son.id,
            index: Object.keys(group.students).length,
            name: son.name,
            group: son.group,
            date: this.when,
            priority: 1,
            email: son.fatherEmail !== "" ? son.fatherEmail : son.motherEmail,
            parentName:
              son.fatherEmail !== "" ? son.fatherName : son.motherName,
            parentGender: son.fatherEmail !== "" ? "male" : "female",
          },
        });
        students
          .doc(son.id)
          .update({
            [`activities.${group.id}`]: {
              activityid: activity.id,
              activityname: activity.name,
              activitymin: activity.min,
              activitymax: activity.max,
              index: Object.keys(group.students).length,
              id: group.id,
              date: group.date,
              name: group.name || "",
              schedule: group.schedule,
              closed: false,
            },
          })
          .then(() => {
            this.getAvailables();
          });
      }
      this.$emit("select", this.student);
    },
    updateComment(activity, son, $event) {
      Object.values(activity.groups).forEach((group) => {
        console.log(group);
        if (group.students[son.id]) {
          activities.doc(activity.id).update({
            [`groups.${group.id}.students.${son.id}.comments`]: $event
          })
        }
      })
      /*console.log($event);
      activities
        .doc(activity.id)
        .update({
          [`comments.${son.id}`]: $event,
        })
        .then(() => {
          console.log("Comentario actualizado");
        });*/
    },
    updateComment2(activity, son, $event) {
      console.log($event);
      activities
        .doc(activity.id)
        .update({
          [`comments.${son.id}`]: $event,
        })
        .then(() => {
          console.log("Comentario actualizado");
        });
    },
    getAvailables() {
      activities
        .where("targets", "array-contains", this.student.group)
        .get()
        .then((activitiesRef) => {
          this.availables = [];
          activitiesRef.forEach((activity) => {
            let available = activity.data();
            Object.values(available.groups).forEach((group) => {
              if (group.students[this.student.id]) {
                available.comments = group.students[this.student.id].comments
              }
            })
            this.availables.push(available);
          });
        });
    },
  },
};
</script>

<style lang="scss">
.groupSelected {
  background-color: red !important;
}
.images {
  margin: 0px;
  padding-top: 7px;
  width: 100%;
  text-align: center;
  //background-color: #0d47a1;
  .thumbnail {
    line-height: 30px;
    margin: 0px;
    padding: 0px;
    margin-left: 5px;
    width: 78px;
    height: 70px;
    overflow: hidden;
    display: inline-block;
  }
}
.price {
  font-size: 1.2em;
}
.group-name {
  margin-left: 5px;
}
.when {
  display: inline-block;
}
</style>